import { t } from "i18next";

import i18n from "@/app/i18n";

import { Option } from "@/shared/utils/options";

import { Equipment } from "./equipment";
import { ExerciseType } from "./exercise-type";
import { FunctionalType } from "./functional-type";
import { Muscle } from "./muscle";
import { TrainingDay } from "./training-day";
import { TrainingObjective } from "./training-objective";

export const TRAINING_DAYS: Array<TrainingDay> = [
  TrainingDay.Monday,
  TrainingDay.Thuesday,
  TrainingDay.Wednesday,
  TrainingDay.Thursday,
  TrainingDay.Friday,
  TrainingDay.Saturday,
  TrainingDay.Sunday,
];

export const objectiveOptions: Array<Option> = [
  {
    element: i18n.t("user.views.hypertrophy"),
    value: TrainingObjective.Hypertrophy,
  },
  {
    element: i18n.t("user.views.definition"),
    value: TrainingObjective.Definition,
  },
  {
    element: i18n.t("user.views.fs"),
    value: TrainingObjective.Health,
  },
];

export const equipmentOptions: Array<Option> = [
  {
    element: i18n.t("user.views.equipment_elastic_band"),
    value: Equipment.ElasticBand,
  },
  {
    element: i18n.t("user.views.equipment_straight_bar"),
    value: Equipment.Barbell,
  },
  { element: i18n.t("user.views.equipment_ez_bar"), value: Equipment.EZBar },
  { element: i18n.t("user.views.equipment_tape"), value: Equipment.Band },
  {
    element: i18n.t("user.views.equipment_dumbbells"),
    value: Equipment.Dumbbell,
  },
  {
    element: i18n.t("user.views.equipment_machines"),
    value: Equipment.Machine,
  },
  { element: i18n.t("user.views.equipment_others"), value: Equipment.Others },
  {
    element: i18n.t("user.views.equipment_lift_own_weight"),
    value: Equipment.OwnWeight,
  },
  { element: i18n.t("user.views.equipment_pulley"), value: Equipment.Pulley },
];

export const muscleOptions: Array<Option> = [
  { element: t("data.muscles.abductor"), value: Muscle.Abductor },
  { element: t("data.muscles.acductor"), value: Muscle.Adductor },
  { element: t("data.muscles.forearm"), value: Muscle.Forearm },
  { element: t("data.muscles.biceps"), value: Muscle.Biceps },
  { element: t("data.muscles.quadriceps"), value: Muscle.Quadriceps },
  { element: t("data.muscles.neck"), value: Muscle.Neck },
  { element: t("data.muscles.core"), value: Muscle.Core },
  { element: t("data.muscles.deltoid"), value: Muscle.Deltoids },
  { element: t("data.muscles.back"), value: Muscle.Back },
  { element: t("data.muscles.calves"), value: Muscle.Calves },
  { element: t("data.muscles.gluteus"), value: Muscle.Buttocks },
  { element: t("data.muscles.isquiotibial"), value: Muscle.Hamstrings },
  { element: t("data.muscles.pectoral"), value: Muscle.Pectorals },
  { element: t("data.muscles.trap"), value: Muscle.Trapezius },
  { element: t("data.muscles.triceps"), value: Muscle.Triceps },
];

export const exerciseTypeOptions: Array<Option> = [
  { element: t("user.views.warm_up"), value: ExerciseType.Warm },
  { element: t("user.views.cardio"), value: ExerciseType.Cardio },
  { element: t("user.views.functional"), value: ExerciseType.Functional },
  { element: t("user.views.stretching"), value: ExerciseType.Stretching },
  { element: t("user.views.strength"), value: ExerciseType.Strength },
  { element: t("user.views.other_sports"), value: ExerciseType.Others },
];

export const functionalExerciseOptions: Array<Option> = [
  { element: t("data.functional.traction"), value: FunctionalType.Traction },
  { element: t("data.functional.thrust"), value: FunctionalType.Thrust },
];

export const searchableOptions: Array<Option> = [
  { element: t("general.yes"), value: true },
  { element: t("general.no"), value: false },
];
